<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/p8B8PQ/tc-custom/9781953368638.jpg?1732166253549" alt="This image is the cover for the book Midwest Pie"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Midwest Pie
      </h1>
      <p class="bookDescription body article font2">
        <b>A historical tour of midwestern pies that recalls when recipes were shared through faded note cards and junior league cookbooks.</b><br/>  <br/> New England may say it’s the “Great American Pie Belt,” but pie has a rich and varied history in the American Midwest too. Stop by any church or community event in the heartland today and you’re likely to see as many types of pie on the dessert table as there are people who made them.<br/>  <br/><i>Midwest Pie</i> highlights the treats, both sweet and savory, that have come to define this region. Here, you’ll learn about bean pie’s origins in the Nation of Islam, the popularity of “desperation pies” during the Depression, how Michigan miners ate lunch “pasties," and much more. Full of accessible instructions and helpful sidebars, you’ll learn the stories behind a variety of pies, including:  Hoosier Pie  Schnitz Pie  Ohio Buckeye Pie  Sawdust Pie  Runza  <i>Midwest Pie</i> is the perfect collection for any home chef looking to learn more about the diversity and deliciousness of one of the region’s most enduring culinary contributions.<br/>  <br/><b>“Recipes spa[n] ‘old classic’ pies such as funeral and sawdust; regional originals like the Nation of Islam’s bean pie and Indiana’s sugar cream Hoosier pie; ‘desperation pies’ that relied on pantry staples when times were tough (chess, shoofly, mock apple); midwestern produce pies (persimmon chiffon); and retro relics (cottage cheese, chocolate rum).” —<i>Chicago Reader</i></b><br/>  <br/><b>“[An] unpretentious little book that will summon up old memories for some and introduce others to an era when seasonality often dictated what sort of pie might show up on the dinner table.” —<i>Booklist</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Meredith Pangrace, Phoebe Mogharei
      </h2>
      
      <p class="authorDescription body article">Meredith Pangrace is a designer and food enthusiast from Cleveland, Ohio. She is the editor of¬†Rust Belt Vegan Kitchen¬†and has designed books for Belt Publishing since 2013. Phoebe Mogharei is Belt Publishing‚Äôs</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Belt Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1200f6ce